import type { FC, ReactElement, ReactNode } from "react"

import { useTranslation } from "react-i18next"

import {
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { ParticipantLayout } from "@/3514/layouts"
import { buildCssClassName } from "@/3514/utils"

type Props = {
    children: ReactNode
    layoutClassName?: string
}

const OffboardingContainer: FC<Props> = ({ children, layoutClassName = String("") }: Props): ReactElement => {
    const { t } = useTranslation()

    return (
        <ParticipantLayout>
            <div className={buildCssClassName(layoutClassName, "pb-[40px] md:pb-[100px]")}>
                <div className="mt-[40px]">
                    <span className="d-block mb-[30px] text-center color-gray fs-14">{t("End-of-Journey")}</span>
                    <Typography
                        text={t("Final Reflection")}
                        className="m-5"
                        tag={ETypographyTag.Heading1}
                        color={ETypographyColor.Black}
                        alignment={ETypographyAlignment.Center}
                        weight={ETypographyWeight.Medium}
                        size={ETypographySize.Heading1}
                        family={ETypographyFamily.DmSerif}
                    />
                </div>

                <div className="container">{children}</div>
            </div>
        </ParticipantLayout>
    )
}

export default OffboardingContainer
